import { ButtonProps } from '@material-ui/core/Button';

export const defaultButtonProps: ButtonProps = {
  color: 'primary',
  fullWidth: true,
  size: 'large',
  variant: 'contained',
};
